import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import CommandPalette from "../../Components/crm/CommandPalette";

export default function DashboardLayout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen((open) => !open);

    return (
        <div className="min-h-screen w-full bg-slate-50 lg:flex">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            <div className="min-w-0 min-h-screen flex-1 overflow-y-auto">
                <Header toggleSidebar={toggleSidebar} />

                <main className="mx-auto w-full max-w-[1800px] p-4 sm:p-5 lg:p-8">{children}</main>
            </div>

            <CommandPalette />
        </div>
    );
}
